import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { PaperMessage } from 'virtues-bootstrap';
import PageLoader from 'components/PageLoading';
import s from './styles.module.scss';

const PaperWithLoader = ({ check, placeholder, error, children, loading }) => {
  if (error) {
    return <div className={s.error}>{error}</div>;
  }

  if (typeof check !== 'undefined' && !check && !loading) {
    return <PaperMessage>{placeholder}</PaperMessage>;
  }

  return loading ? <PageLoader /> : children;
};

PaperWithLoader.defaultProps = {
  children: null,
  check: true,
  error: null,
  loading: false,
  placeholder: 'Data not found',
};

PaperWithLoader.propTypes = {
  error: PropTypes.string,
  placeholder: PropTypes.string,
  loading: PropTypes.bool,
  check: PropTypes.bool,
  children: PropTypes.node,
};

export default withTranslation()(PaperWithLoader);
